import { z } from 'zod';

export const JobListingSchema = z.object({
  title: z.string().min(1, 'Title is required'),
  openings: z.coerce.number().min(1, 'Must have at least one opening'),
  skills: z.array(z.string()).optional(),
  requirements: z.array(z.string()).optional(),
  whatYouBring: z.array(z.string()).optional(),
  perks: z.array(z.string()).optional(),
  keywords: z.array(z.string()).optional(),
  tags: z.array(z.string()).optional(),
  testUrl: z.string().min(1, 'Test URL is required'),
  thresholdScore: z.string().min(0, 'Threshold score is required'),
});

export type JobListing = z.infer<typeof JobListingSchema>;
